module.exports = __webpack_public_path__ + "img/logo-icon-app.d306d750.png";